/*
  Список перечислений для диаграмм
*/

/*
Тип режима диаграммы
*/

export enum DiagramModeType {
  View = 'view',
  Cursor = 'cursor',
  Action = 'action',
}

/*
Тип курсора
*/

export enum CursorType {
  Cursor = 'cursor',
  MarkerCursor = 'markerCursor',
  ModulationCursor = 'modulationCursor',
  HarmonicCursor = 'harmonicCursor',
  SubHarmonicCursor = 'subHarmonicCursor',
}

/*
Тип действия
*/

export enum DiagramActionType {
  FindPeaks = 'findPeaks',
}

/*
Тип диаграммы
*/
export enum DiagramType {
  Signal = 'signal',
  Spectrum = 'spectrum',
}

/*
Тип спектра
 */
export enum SpectrumEventType {
  Low = 0,
  Envelop = 1,
  Energy = 2,
}

/*
Тип оси dtcp-акселерометра
*/
export enum DtcpAcceleromerModuleAxisType {
  X = 0,
  Y = 1,
  Z = 2,
}

/*
Тип аггрегации интервального спектра
 */
export enum SpectrumIntervalAggregateType {
  Avg = 0,
  Max = 1,
}

/*
Тип зума диаграммы
*/
export enum DiagramZoomType {
  X = 'x',
  Y = 'y',
  XY = 'xy',
  None = '',
}

/*
Тип оси Y для спектра
*/
export enum SpectrumYAxisType {
  VDecibels = 'vdecibelle', //Логарифмическая шкала
  VAcceleration = 'vacceleration', //Виброускорение
  VVelocity = 'vvelocity', //Виброскорость
}
